
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Converter } from "@/containers/Converter";
import { Head } from "@/components/Head";

import { MagicianSection } from "@/sections/MagicianSection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";

import { useTheme } from "@/hooks/useTheme";
import { CTASection } from "@/sections/CTASection";
import { TrustedBySection } from "@/sections/TrustedBySection";

const IndesignToFigma = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/FigmaToIndesign"
        ogImage="/images/figma2indd-og-image.jpg"
      />

      <MagicianSection
        title={t("page/FigmaToIndesign:title")}
        subtitle={t("page/FigmaToIndesign:subtitle")}
        magicianLogoFile="figma"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/FigmaToIndesign:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/figma-to-indesign-converter-example.png",
          alt: "Figma to InDesign converter example",
        }}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/FigmaToIndesign:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/FigmaToIndesign:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/import-pdf-into-indesign.jpg",
          alt: t("page/FigmaToIndesign:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/FigmaToIndesign:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/FigmaToIndesign:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/FigmaToIndesign:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/FigmaToIndesign:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/FigmaToIndesign:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "IMAGE-RED-ICON",
            title: t(
              "page/FigmaToIndesign:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/FigmaToIndesign:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          {
            iconType: "CHECK-GREEN-ICON",
            text: t("section/conversion:badges.accuracy"),
          },
        ]}
        elements={{
          from: {
            iconType: "FIGMA",
            image: "/images/figma-preview.jpg",
            title: "Figma Demo Preview",
          },
          to: {
            iconType: "INDESIGN",
            image: "/images/indesign-preview.jpg",
            title: "Indesign Demo Preview",
          },
        }}
      />
      <CustomersLogosSection />

      <SelectFormatSection title={t("section/selectFormat:title")} />
      <CTASection
        title={t("section/cta:titles.figmaToIndesignPage")}
        href="#upload"
        isBetaFormat
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default IndesignToFigma;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/figma-to-indesign',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  